module.exports = __webpack_public_path__ + "static/media/achievement-secret-superpower.98a60b89.svg";